export default __webpack_public_path__ + "static/housing-dining-mobile-634d4c145ccc78e17486066ee8626144.jpg";